export default "__VITE_ASSET__CxHV1FHz__"